<template>
  <div class="flex flex-col timeline">
    <div
      v-for="(item, index) in timeline.items"
      :key="item[0] || item[1]"
      class="flex"
    >
      <div class="mr-2">
        <div
          :class="classForCheck(index, timeline.activeIndex)"
          class="flex items-center justify-center rounded-full checkbox text-white"
        >
          <Tick v-if="checkShouldBeTicked(index, timeline.activeIndex)" />
          <Dots v-if="checkShouldBeInProgress(index, timeline.activeIndex)" />
        </div>
        <div
          v-if="(index != timeline.items.length - 1)"
          :class="classForBar(index, timeline.activeIndex)"
          class="flex-1 w-px h-full m-auto"
        />
      </div>
      <div
        :class="{
          'base-border-b mb-3': (index != timeline.items.length - 1),
          'custom-text-grey': checkShouldBeGrey(index, timeline.activeIndex),
          'text-orange': checkShouldBeInProgress(index, timeline.activeIndex),
        }"
        class="flex-1 timeline-text pb-3 text-lg"
      >
        <template v-if="checkShouldBeTicked(index, timeline.activeIndex)">
          {{ item[1] }}
        </template>
        <template v-else>
          {{ item[0] }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Tick from './icons/Tick.vue';
import Dots from './icons/Dots.vue';

export default {
  name: 'BaseTimeline',
  components: {
    Tick,
    Dots,
  },
  props: {
    timeline: {
      type: Object,
      required: true,
    },
  },
  methods: {
    classForBar(index, activeIndex) {
      const shouldbeOrange = index < activeIndex;
      return {
        'bg-orange': shouldbeOrange,
        'bg-grey-light': !shouldbeOrange,
      };
    },
    checkShouldBeTicked(index, activeIndex) {
      return index < activeIndex;
    },
    checkShouldBeGrey(index, activeIndex) {
      return index > activeIndex;
    },
    checkShouldBeInProgress(index, activeIndex) {
      return index === activeIndex;
    },
    classForCheck(index, activeIndex) {
      return {
        'bg-orange': this.checkShouldBeInProgress(index, activeIndex),
        'bg-timeline-grey': this.checkShouldBeGrey(index, activeIndex),
        'border border-orange bg-white': this.checkShouldBeTicked(index, activeIndex),
      };
    },
  },
};
</script>

<style lang="css" scoped>
.checkbox {
  height: 21px;
  width: 21px;
}
.timeline-text {
  line-height: 21px;
}
.bg-timeline-grey {
  background-color: #EAECEF;
}
.custom-text-grey {
  color: rgba(48, 67, 92, 0.5);
}
</style>
